module.exports = __webpack_public_path__ + "static/Arkivet_43-d9826b1eea2f3cd6145de464c6579fb8.jpg";